import type { HealthDto } from "@nabla/api";
import { designCopy } from "../copy.ts";
import { formatAt, formatTime, saoPaulo } from "./dates.ts";

const labels: Readonly<Record<string, { readonly f: string; readonly m: string }>> = {
  ACTIVE: { f: "Ativa", m: "Ativo" },
  PAUSED: { f: "Pausada", m: "Pausado" },
  CAMPAIGN_PAUSED: { f: "Pausado pela campanha", m: "Pausado pela campanha" },
  ADSET_PAUSED: { f: "Pausado pelo conjunto", m: "Pausado pelo conjunto" },
  IN_PROCESS: { f: "Em processamento", m: "Em processamento" },
  WITH_ISSUES: { f: "Com problemas", m: "Com problemas" },
  PENDING_REVIEW: { f: "Em análise do Meta", m: "Em análise do Meta" },
  DISAPPROVED: { f: "Reprovado", m: "Reprovado" },
  PENDING_BILLING_INFO: { f: "Falta pagamento", m: "Falta pagamento" },
  ARCHIVED: { f: "Arquivada", m: "Arquivado" },
  DELETED: { f: "Excluída", m: "Excluído" },
};

export function statusLabel(status: string, gender: "f" | "m"): { readonly text: string; readonly known: boolean } {
  const label = labels[status];
  return label === undefined ? { text: status, known: false } : { text: label[gender], known: true };
}

type HealthText = { readonly text: string; readonly tone: "atencao" | "negativo"; readonly round?: true };

export function healthText(health: HealthDto | undefined, now: number): HealthText | undefined {
  const s = designCopy.saude;
  if (health?.schedule === "atrasada") return { text: s.agendaAtrasada, tone: "atencao" };
  if (health?.schedule === "parada" && health.lastBeatAt) {
    return { text: s.agendaParada(formatTime(health.lastBeatAt, saoPaulo)), tone: "negativo" };
  }
  const round = health?.optimization;
  const at = (when: string) => formatAt(when, new Date(now).toISOString(), saoPaulo);
  if (round?.state === "falhou") return { text: s.rodadaFalhou(at(round.at)), tone: "negativo", round: true };
  return round?.state === "indisponivel" ? { text: s.rodadaIlegivel(at(round.at)), tone: "atencao", round: true } : undefined;
}
